export default "__VITE_ASSET__CmTsTUbK__"